import { type PropsWithChildren, useMemo } from "react";

import { permissionsContext } from "../config";
import { useAllGroupPermissions } from "../hooks/use-all-groups-permissions";
import { useGroupPermissions } from "../hooks/use-group-permissions";
import { useOrgPermissions } from "../hooks/use-org-permissions";
import type { IPermissionsContext } from "../types";

const PermissionsProvider = (props: PropsWithChildren<object>): JSX.Element => {
  const { children } = props;

  const { loading: orgLoading, permissionMethods: orgPermissionMethods } =
    useOrgPermissions();

  const { loading: groupLoading, permissionMethods: groupPermissionMethods } =
    useGroupPermissions();

  const {
    loading: allGroupLoading,
    permissionMethods: allGroupPermissionMethods,
    organizations,
  } = useAllGroupPermissions();

  const values = useMemo(
    (): IPermissionsContext => ({
      groupPermissions: groupPermissionMethods,
      loading: orgLoading || groupLoading || allGroupLoading,
      organizationPermissions: orgPermissionMethods,
      organizations,
      someGroupPermissions: allGroupPermissionMethods,
    }),
    [
      allGroupLoading,
      allGroupPermissionMethods,
      groupLoading,
      groupPermissionMethods,
      orgLoading,
      orgPermissionMethods,
      organizations,
    ],
  );

  return (
    <permissionsContext.Provider value={values}>
      {children}
    </permissionsContext.Provider>
  );
};

export { PermissionsProvider };
